export default __webpack_public_path__ + "static/media/kitchen3-before2-1024w.9faa967e.webp";